import {useGetPeepOpenTasksCount} from '../../../shared/tasks-widget/hooks/use-get-peep-open-tasks-count';

import {useGetScheduledActivitiesCount} from '../../../../core-entity/widgets/activities-widget/hooks/use-get-scheduled-activities-count';
import type {WidgetCounts} from '../../../../core-entity/workspace/helpers';

import {useGetRelatedAccountsCount} from '../related-accounts-widget/hooks/use-get-related-accounts-count';

export function useGetWidgetCounts(entityId: string): WidgetCounts {
    const scheduledActivitiesCount = useGetScheduledActivitiesCount(entityId);
    const relatedAccountsCount = useGetRelatedAccountsCount(entityId);
    const openTasksCount = useGetPeepOpenTasksCount(entityId);

    return {
        tasks: openTasksCount,
        activities: scheduledActivitiesCount,
        relatedAccounts: relatedAccountsCount,
    };
}
